import {
  NOTIFICATION_CARD_DEFAULT_CATEGORY,
  NOTIFICATION_CATEGORY_BY_TYPE_PREFIX,
  NOTIFICATION_MODULE_LABEL_BY_KEY,
} from "../config/notification-card.config.js";

/**
 * Resolve o label da badge do módulo.
 * Prioridade: `metadata.context.module` → fallback por prefixo de `type` → Geral.
 *
 * @param {{ module?: string|null, type?: string|null }} [input]
 * @returns {string}
 */
export function resolveNotificationCategoryLabel(input = {}) {
  const moduleKey =
    typeof input?.module === "string" ? input.module.trim().toLowerCase() : "";

  if (moduleKey) {
    const fromModule = NOTIFICATION_MODULE_LABEL_BY_KEY[moduleKey];
    if (fromModule) return fromModule;
  }

  const type =
    typeof input?.type === "string" ? input.type.trim().toLowerCase() : "";
  if (type) {
    const match = NOTIFICATION_CATEGORY_BY_TYPE_PREFIX.find((entry) =>
      type.startsWith(entry.prefix.toLowerCase()),
    );
    if (match?.label) return match.label;
  }

  return NOTIFICATION_CARD_DEFAULT_CATEGORY;
}
